export const CONTACT = {
  whatsapp: "5516997932948",
  phone: "(16) 99793-2948",
  instagram: "alfagraficadigital",
  site: "alfagrafica.com.br",
  address: "Av. Victor Maida, 517 — Ibitinga, SP",
  hours: "Seg a Sex 09h às 18h · Sáb 09h às 12h",
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const BENEFITS = [
  { title: "Arte", sub: "criação e arte-final" },
  { title: "Impressão", sub: "digital profissional" },
  { title: "Acabamento", sub: "cuidado em cada detalhe" },
  { title: "Médias tiragens", sub: "sob medida para empresas" },
];

export const DIFFERENTIALS = [
  { n: "01", title: "Impressão profissional", desc: "Equipamentos e materiais para resultados consistentes." },
  { n: "02", title: "Médias tiragens", desc: "Produção sob medida para a necessidade da sua empresa." },
  { n: "03", title: "Atendimento empresarial", desc: "Orçamentos e acompanhamento direto." },
  { n: "04", title: "Agilidade", desc: "Produção eficiente para você não perder prazo." },
];

export const SOLUTIONS = [
  { id: "impressao-digital", title: "Impressão Digital", desc: "Folhetos, flyers, folders, encartes, catálogos, cartões, tags, cardápios e apostilas.", img: "/img/p-folhetos.jpg" },
  { id: "adesivos-etiquetas", title: "Adesivos e Etiquetas", desc: "Adesivos personalizados, vinil, recortados, etiquetas, rótulos e adesivos para vitrines.", img: "/img/p-adesivos.jpg" },
  { id: "comunicacao-visual", title: "Comunicação Visual", desc: "Banners, lonas, faixas, placas ACM, placas PVC, sinalização e placas de identificação.", img: "/img/p-banners.jpg" },
  { id: "materiais-empresas", title: "Materiais para Empresas", desc: "Catálogos, folders, cartões, tags, etiquetas, crachás e papelaria.", img: "/img/p-catalogos.jpg" },
  { id: "e-commerce", title: "E-commerce", desc: "Tags, etiquetas, rótulos, adesivos, cartões e materiais para pedidos.", img: "/img/p-ecommerce.jpg" },
  { id: "design", title: "Design", desc: "Criação, arte-final, vetorização e preparação de arquivos.", img: "/img/p-design.jpg" },
];

export const CATALOG = [
  { id: "folhetos", title: "Folhetos", desc: "Para promoções, ofertas e divulgação do seu comércio.", img: "/img/p-folhetos.jpg" },
  { id: "flyers", title: "Flyers", desc: "Divulgação de eventos, serviços e lançamentos.", img: "/img/p-flyers.jpg" },
  { id: "cartoes", title: "Cartões", desc: "Cartões de visita que apresentam sua marca com profissionalismo.", img: "/img/p-cartoes.jpg" },
  { id: "folders", title: "Folders", desc: "Com dobras, para apresentar empresa e serviços.", img: "/img/p-folders.jpg" },
  { id: "catalogos", title: "Catálogos", desc: "Apresente sua linha de produtos de forma organizada.", img: "/img/p-catalogos.jpg" },
  { id: "etiquetas", title: "Etiquetas", desc: "Identificação de produtos, embalagens e pedidos.", img: "/img/p-etiquetas.jpg" },
  { id: "rotulos", title: "Rótulos", desc: "Para potes, frascos e garrafas com a cara da sua marca.", img: "/img/p-rotulos.jpg" },
  { id: "tags", title: "Tags", desc: "Para roupas, presentes e produtos de e-commerce.", img: "/img/p-tags.jpg" },
  { id: "adesivos", title: "Adesivos", desc: "Personalizados, em vinil ou recortados no formato da sua arte.", img: "/img/p-adesivos.jpg" },
  { id: "banners", title: "Banners", desc: "Para lojas, eventos, feiras e pontos de venda.", img: "/img/p-banners.jpg" },
  { id: "placas-acm", title: "Placas ACM", desc: "Fachadas e painéis resistentes com acabamento profissional.", img: "/img/p-placa-acm.jpg" },
  { id: "placas-pvc", title: "Placas PVC", desc: "Sinalização interna e placas de identificação.", img: "/img/p-placa-pvc.jpg" },
];
